/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import Api from '../Apis/api.service'
import Footer from './partials/Footer'
import Title from './partials/Title'
import IntroResolutions, { BaseUnit } from './partials/IntroResolutions'
import { Box, Paper, Typography } from '@material-ui/core'
import useStyles, { customTheme } from './styles/styles'
import moment from 'moment-timezone'
import { url2, urlQrCode } from '../utils'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { PostalVotingPage } from './partials/PostalVoting'
import { PouvoirAG } from './partials/PouvoirAG'
import { TIMEZONE } from '../config'
const ConvocationPaper = (props) => {
  const { ag_id, coowner_id } = useParams()
  const [details, setDetails] = useState({})
  const [pvagsConvocation, setPvagsConvocation] = useState({})
  const [loaded, setLoaded] = useState(false)

  const getDetails = async () => {
    const res = await Api.ags.getDetailsCoownerAndAgs({ ag_id, coowner_id })
    if (res.status == 200) {
      setDetails(res.data)
    }
    const resPvConvocation = await Api.pvags.getPvagsconvocation(ag_id)
    if (resPvConvocation.status == 200) {
      setPvagsConvocation(resPvConvocation.data)
    }
    // Signale au moteur de capture PDF (Puppeteer côté back-legacy) que toutes les
    // données sont chargées et rendues. Tant que ce marqueur est absent, la capture
    // n'a pas lieu : on évite ainsi les champs de fusion "undefined" dus à une
    // capture trop précoce. Voir CONVOCATION_SCREENING_OPTIONS.readySelector.
    if (res.status == 200 && resPvConvocation.status == 200) {
      setLoaded(true)
    }
  }

  useEffect(() => {
    console.log({ ag_id, coowner_id })
    getDetails()
  }, [ag_id])

  const { withMargin } = useStyles()
  const theme = customTheme(details?.pv_font_size)
  return (
    <MuiThemeProvider theme={theme}>
      <Box component={Paper}>
        {loaded && (
          <div data-convocation-ready="true" style={{ display: 'none' }} />
        )}
        <div className="page-header"></div>
        <table className={withMargin}>
          <thead>
            <tr>
              <td>
                <div className="page-header-space">&nbsp;</div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {loaded && (
                  <ConvocationPaperContainer
                    details={details}
                    pvagsConvocation={pvagsConvocation}
                    isDigital={false}
                    {...props}
                  />
                )}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div style={{ height: '50px' }}>&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>

        <Footer />
      </Box>
    </MuiThemeProvider>
  )
}
export const ConvocationPaperContainer = ({
  details,
  pvagsConvocation,
  generic = false,
  ...props
}) => {
  if (!pvagsConvocation || !details) return null

  if (generic)
    return (
      <BaseUnit>
        <Title record={pvagsConvocation} details={details} />
        <IntroResolutions record={pvagsConvocation} />
      </BaseUnit>
    )
  return (
    <>
      <Convocation details={details} showLogo={props.showLogo} />
      <br />
      {/*<BaseUnit>*/}
      {/*  <div*/}
      {/*    style={{*/}
      {/*      pageBreakBefore: 'always',*/}
      {/*      pageBreakAfter: 'always',*/}
      {/*    }}*/}
      {/*  ></div>*/}
      {/*</BaseUnit>*/}
      <BaseUnit>
        <PouvoirAG pvagsConvocation={pvagsConvocation} details={details} />
      </BaseUnit>
      <BaseUnit>
        <PostalVotingPage {...props} />
      </BaseUnit>
    </>
  )
}
const poidsPapier = (nbLot) => {
  if (!nbLot) return ''
  let poids = parseInt(nbLot) * 1000
  return poids < 1000
    ? `${poids.toFixed(0)}g `
    : `${(poids / 1000).toFixed(0)}kg `
}
const co2 = (nbLot) => {
  if (!nbLot) return ''
  let co2 = parseInt(nbLot) * 10.22 * 100
  return co2 < 1000 ? `${co2.toFixed(0)}g ` : `${(co2 / 1000).toFixed(0)}kg `
}
export const Convocation = ({ details, showLogo = true }) => {
  const date = moment.utc(details?.date).tz(TIMEZONE).format('LLL')
  return (
    <div style={{ breakInside: 'avoid', marginTop: showLogo ? '-140px' : '' }}>
      {showLogo && (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={url2} width="200" />
          </div>
          <br />
          <br />
        </>
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          width: '100%',
        }}
      >
        {/* Section gauche : Ton contenu initial */}
        <div className="pdf-letter__header" style={{ maxWidth: '70%' }}>
          <Typography variant="h5">
            <b>Convocation</b>
          </Typography>
          <br />
          <br />
          <div className="pdf-letter__header">
            {details?.coproprietaire && (
              <Typography variant="body2">
                <b>{`Copropriétaire : ${details?.coproprietaire}`}</b>
              </Typography>
            )}
            {details?.adresse && (
              <Typography variant="body2">
                <b>
                  Copropriété située au : {details?.adresse}
                  {` - ${details?.ville}` || ''}
                </b>
              </Typography>
            )}

            <Typography variant="body2">
              <b>Assemblée Générale du : {date}</b>
            </Typography>
          </div>
          <br />
          <br />
        </div>
        <div
          style={{
            textAlign: 'right',
            lineHeight: '1.8',
            maxWidth: '30%',
          }}
        >
          <Typography variant="body2">
            <b>{details?.coproprietaire}</b>
          </Typography>
          {details?.full_name && (
            <Typography variant="body2">
              <b>{`C/O ${details?.full_name}`}</b>
            </Typography>
          )}

          {details?.digital_consent ? (
            <Typography variant={'body2'}>{details?.contact_mail}</Typography>
          ) : (
            <>
              {' '}
              <Typography variant="body2">
                {details?.contact_adresse}
              </Typography>
              <Typography variant="body2">
                {details?.contact_cp} {details?.contact_ville}
              </Typography>
            </>
          )}
        </div>
      </div>
      <br />
      <br />

      <Typography variant="body2">Madame, Monsieur,</Typography>
      <br />
      <Typography variant="body2">
        Conformément à la loi du 10 Juillet 1965 (modifiée par la loi du
        31/12/1985 et le décret du 09/06/1986) et au règlement de copropriété,
        nous vous invitons à participer à l'Assemblée Générale de votre
        copropriété qui se tiendra le :
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          textAlign: 'center',
        }}
      >
        <b>{date}</b>
      </Typography>
      <br />
      <div
        style={{
          border: '1px solid black',
          padding: '10px',
          borderRadius: '10px',
          breakInside: 'avoid',
        }}
      >
        <Typography variant="body2">
          <b>Tenue de votre Assemblée Générale</b>
        </Typography>
        <Typography variant="body2">
          L’Assemblée Générale se tiendra selon les moyens et supports suivants
          :
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">Accès : {details?.lieu}</Typography>
          </li>
          <li>
            <Typography variant="body2">
              Vote par correspondance par formulaire à renvoyer; le formulaire
              de vote doit être réceptionné au plus tard 3 jours francs avant la
              date de la réunion.
            </Typography>
          </li>
        </ul>
      </div>
      <div
        style={{
          border: '1px solid black',
          padding: '10px',
          borderRadius: '10px',
          marginTop: '10px',
          lineHeight: '12.8px',
          breakInside: 'avoid',
        }}
      >
        <Typography variant="body2">
          <b>Accès en ligne à votre espace Assemblée Générale</b>
        </Typography>
        <Typography variant="body2" style={{ lineHeight: '2' }}>
          Toutes les informations d’accès à l’assemblée générale sont
          disponibles en ligne, sur votre espace sécurisé.
        </Typography>
        <Typography variant="body2" style={{ lineHeight: 'unset' }}>
          Vous pouvez d'ores et déjà vous connecter sur
          https://syndic.manda.fr/ag avec le code <b>{details?.code}</b> pour :
        </Typography>
        <table>
          <tr>
            <td>
              <ul>
                <li>
                  <Typography variant="body2">
                    Enregistrer votre vote par correspondance
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    Accéder à une copie numérique du formulaire de pouvoir
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    Consulter la version numérique de la convocation
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    Consulter les documents joints
                  </Typography>
                </li>
              </ul>
            </td>
            <td>
              <img width="100" src={urlQrCode} />
            </td>
          </tr>
        </table>
      </div>

      {/* BEGINING BLOC 3 */}
      <div
        style={{
          border: '1px solid black',
          padding: '10px',
          borderRadius: '10px',
          marginTop: '10px',
          breakInside: 'avoid',
        }}
      >
        <Typography variant="body2">
          <b>Accès à vos documents et annexes</b>
        </Typography>
        <Typography variant="body2" style={{ lineHeight: '2' }}>
          Vous souhaitez une copie de l’ensemble de vos documents ?
        </Typography>
        <table>
          <tr>
            <td>
              <ul>
                <li>
                  <Typography variant="body2">
                    <b>Les documents sont également envoyés par e-mail</b>, si
                    nous disposons de vos coordonnées électroniques - jetez-y un
                    oeil !
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <b>
                      Vous disposez de l’ensemble des documents et annexes sur
                      votre espace sécurisé dédié à l’assemblée générale
                    </b>
                    , ou directement sur votre Extranet
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <b>Vous pouvez faire une demande par e-mail</b>, sur
                    copro@manda.fr, par téléphone au 01 79 73 11 12, et nous
                    vous renverrons une copie de tout document par mail ou par
                    courrier à votre convenance
                  </Typography>
                </li>
              </ul>
            </td>
          </tr>
        </table>
      </div>
      {/* END BLOC 3 */}

      {/* BEGINING BLOC 4 */}
      <div
        style={{
          border: '1px solid black',
          padding: '10px',
          borderRadius: '10px',
          marginTop: '10px',
          breakInside: 'avoid',
        }}
      >
        <Typography variant="body2">
          <b>Le saviez-vous ?</b>
        </Typography>
        <Typography variant="body2" style={{ lineHeight: '2' }}>
          L’envoi des convocations par format électronique, un enjeu majeur ! »
        </Typography>
        <table>
          <tr>
            <td>
              <ul>
                <li>
                  <Typography variant="body2">
                    Un intérêt écologique : {poidsPapier(details?.lotnumber)} de
                    papier dans le cas de votre copropriété, et c'est également{' '}
                    {co2(details?.lotnumber)}
                    d'équivalents CO2 évités !
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    Un intérêt économique pour la copropriété : un envoi
                    exclusivement électronique des convocations permet à la
                    copropriété de supprimer les frais d’affranchissement.
                  </Typography>
                </li>
              </ul>
            </td>
          </tr>
        </table>
      </div>
      {/* END BLOC 4 */}

      <br />
      <Typography variant="body2">
        Au cas où vous ne pourriez pas assister à la présente Assemblée
        Générale, nous vous serions reconnaissants de bien vouloir utiliser le
        pouvoir joint, au nom d'un mandataire de votre choix. Le syndic ne peut
        accepter de procuration.
      </Typography>
      <br />
      <Typography variant="body2">
        Nous vous prions d'agréer, Madame, Monsieur, l'expression de nos
        sincères salutations.
      </Typography>

      <br />
      <Typography
        variant="h4"
        style={{
          textAlign: 'center',
          marginTop: '100px',
        }}
      >
        <img width="200" src={urlQrCode} />
        <br />
        N'oubliez pas de vous enregistrez à l'AG
        <br />
        en scannant ce QRCode au moins 24h à l'avance
      </Typography>
    </div>
  )
}
export default ConvocationPaper
